import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './Component/Dashboard/Dashboard';
import Dashboard_new from './Component/Dashboard/Dashboard_new';
import Login from './Login/Login';
import ApexChart from './Component/ApexChart';
import ApexChartBar from './Component/ApexChartBar';
import CustomChart from './Component/CustomChart';
import LineChart from './Component/LineChart';
import Table from './Component/Dashboard/Table/Table';
import PrivateRoute from './PrivateRoute'; // Import PrivateRoute

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route path="/Login" element={<Login />} />
          <Route path="*" name="Login" element={<Login />} />

          <Route
            path="/Dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/Dashboard_new"
            element={
              <PrivateRoute>
                <Dashboard_new />
              </PrivateRoute>
            }
          />
          <Route
            path="/ApexChart"
            element={
              <PrivateRoute>
                <ApexChart />
              </PrivateRoute>
            }
          />
          <Route
            path="/CustomChart"
            element={
              <PrivateRoute>
                <CustomChart />
              </PrivateRoute>
            }
          />
          <Route
            path="/ApexChartBar"
            element={
              <PrivateRoute>
                <ApexChartBar />
              </PrivateRoute>
            }
          />
          <Route
            path="/LineChart"
            element={
              <PrivateRoute>
                <LineChart />
              </PrivateRoute>
            }
          />
          <Route
            path="/Table"
            element={
              <PrivateRoute>
                <Table />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
